import { withInstall, withNoopInstall } from '@sgui-plus/utils/with-install'
import Button from './src/button.vue'
import ButtonGroup from './src/button-group.vue'

export const SgButton = withInstall(Button, {
  ButtonGroup,
})
export const SgButtonGroup = withNoopInstall(ButtonGroup)
export default SgButton

export * from './src/button'
export * from './src/constants'
